import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export { sentryCreateBrowserRouter };
